import cache from "./cache";
import eesbucache from "./eesbucache";

export default [
  cache,
  eesbucache
]



// WEBPACK FOOTER //
// ./src/store/cache/index.js